import ProduitsController from './produits.controller';

export default {
    controller: ProduitsController,
    template: require('./produits.tpl.html')
};
